import { Mail, MessageSquare, FileText, Hash, Calendar, List, CheckSquare, Paperclip, MapPin, Phone } from "lucide-react";
import { card } from "@/components/org/intake/intakeMeta";

const ICONS = {
  short_text: FileText, long_text: FileText, email: Mail, phone: Phone, address: MapPin,
  dropdown: List, multiple_choice: List, checkbox: CheckSquare, date: Calendar, number: Hash, file: Paperclip,
};

const PreviewField = ({ field }) => {
  const Icon = ICONS[field.type] || MessageSquare;
  return (
    <div className="mb-3" data-testid={`field-preview-${field.field_id}`}>
      <label className="flex items-center gap-1.5 text-xs font-bold text-slate-600 dark:text-slate-300">
        <Icon size={12} className="text-slate-400" /> {field.label || "Untitled field"} {field.required && <span className="text-red-500">*</span>}
      </label>
      {field.description && <p className="mt-0.5 text-[11px] text-slate-400">{field.description}</p>}
      {(field.type === "dropdown" || field.type === "multiple_choice") ? (
        <div className="mt-1 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-400 dark:border-white/10 dark:bg-white/5">
          {field.options?.length ? field.options.join(" · ") : "No options added"}
        </div>
      ) : field.type === "checkbox" ? (
        <div className="mt-1 flex items-center gap-2 text-xs text-slate-400"><span className="h-4 w-4 rounded border border-slate-300" /> {field.placeholder || "Yes"}</div>
      ) : field.type === "long_text" ? (
        <div className="mt-1 h-14 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-300 dark:border-white/10 dark:bg-white/5">{field.placeholder}</div>
      ) : (
        <div className="mt-1 h-8 rounded-lg border border-slate-200 bg-slate-50 px-3 py-1.5 text-xs text-slate-300 dark:border-white/10 dark:bg-white/5">{field.placeholder}</div>
      )}
    </div>
  );
};

export const LiveFormPreview = ({ fields, modelName }) => (
  <div className={`${card}`} data-testid="intake-live-preview">
    <p className="text-xs font-bold uppercase tracking-[0.1em] text-slate-400">Live Preview</p>
    <div className="mt-3 rounded-xl border border-slate-200 bg-white p-4 dark:border-white/10 dark:bg-[#0B1220]">
      <p className="text-sm font-extrabold text-slate-950 dark:text-white">{modelName || "Untitled Intake Model"}</p>
      <div className="mt-3">
        {fields.length === 0 ? (
          <p className="text-xs text-slate-400">Add fields to see them appear here.</p>
        ) : (
          fields.map((f) => <PreviewField key={f.field_id} field={f} />)
        )}
      </div>
    </div>
  </div>
);
